import {
  Video as VideoIcon,
  FileText,
  CheckCircle,
  XCircle,
  Edit,
  Clock as HourglassIcon,
  Slash,
} from 'react-feather'

import { OrderStatus } from '@/core/graphql/types'
import { IconText } from '@/components/ui/IconText'

import { getBgColorByStatus, getOrderStatusLabel, getTextColorByStatus } from '../lib/orderStatus'

function getStatusIcon(status: OrderStatus) {
  switch (status) {
    case OrderStatus.Accepted:
      return <CheckCircle size={14} />
    case OrderStatus.ConsultationCreated:
      return <VideoIcon size={14} />
    case OrderStatus.ExpertiseCreated:
      return <FileText size={14} />
    case OrderStatus.Canceled:
      return <Slash size={14} />
    case OrderStatus.Refused:
      return <XCircle size={14} />
    case OrderStatus.Pending:
      return <HourglassIcon size={14} />
    case OrderStatus.Draft:
      return <Edit size={14} />
    default:
      return null
  }
}

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  return (
    <IconText
      icon={getStatusIcon(status)}
      text={getOrderStatusLabel(status)}
      className={`rounded-md ${getBgColorByStatus(status)} px-2 py-1 font-medium ${getTextColorByStatus(status)}`}
    />
  )
}
